import { render } from "./SummerCampAdd.vue?vue&type=template&id=f070718e&scoped=true"
import script from "./SummerCampAdd.vue?vue&type=script&lang=js"
export * from "./SummerCampAdd.vue?vue&type=script&lang=js"

import "./SummerCampAdd.vue?vue&type=style&index=0&id=f070718e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f070718e"]])

export default __exports__